import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { apiUrlComponent } from '../common/api.url.component';
import { ApiService } from '../common/API/api.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import {MatPaginator, MatTableDataSource} from '@angular/material';
import * as $ from 'jquery';
import {BackRestrict} from '../common/backRestrict'

declare var config;

@Component({
  selector: 'app-enterprise',
  templateUrl: './enterprise.component.html',
  styleUrls: ['./enterprise.component.css']
})
export class EnterpriseComponent implements OnInit {
  
  @ViewChild('addEnterpriseBtn') addEnterpriseBtn: ElementRef;
 // public Enterpriselist: any;
  public form: FormGroup;
  public callForAddEnterprise: boolean = true;
  public submitted: boolean = false;
  public Enterpriselist : EnterpriseInfo[]= [];
  public dataSource :  MatTableDataSource<EnterpriseInfo>;
  // public EnterpriseInfo
  private readonly notifier: NotifierService;
  constructor(private _apiService: ApiService, private renderer: Renderer2, private formbuilder: FormBuilder,
    private apiUrl: apiUrlComponent, notifierService: NotifierService,private backrestrict:BackRestrict) {
    this.form = formbuilder.group({
      EnterpriseID: [''],
      Enterprise: ['', Validators.required],
    });
    this.notifier = notifierService;
    
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  public pageSizeOptions=[5,10,15,20];
  public pageSize=10;
  public length=10;
  public displayedColumns  = ['BaseEnterpriseID', 'BaseEnterprise', 'Action', 'IsActive'];
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ngOnInit() {
    this.backrestrict.clearBrowserBackHistory();
    this.GetEnterprise();
   
  }

  GetEnterprise() {
    this._apiService.get(config.urlpath + 'api/enterprise').subscribe(result => {
      if (result.Success === true) {
        debugger;
       // this.Enterpriselist = result.Data;
       this.Enterpriselist =  result.Data;
       this.dataSource = new MatTableDataSource(this.Enterpriselist);
       this.dataSource.paginator = this.paginator;
      //  this.dataSource = result.Data;
      } else {
        this.notifier.notify('error', 'An Error Occured');
      }
    },
      error => {
        console.log(error);
      }
    );
  }

  emptyform() {
    this.callForAddEnterprise = true;
    this.form.reset();
  }

  AddEnterprise() {
    if (this.form.valid) {
      debugger
      if(this.form.value.Enterprise.toLowerCase()!=='corporate')
      {
        this._apiService.post(config.urlpath + 'api/addenterprise', this.form.value).subscribe(result => {
          if (result.Success === true) {
            $('#ModalClsbtn').click();
            this.GetEnterprise();
            this.notifier.notify('success', 'Base Enterprise Added Successfully');
          } else {
            this.notifier.notify('error', 'An Error Occured');
          }
        },
          error => {
            console.log(error);
          }
        );
      }
      else{
        this.notifier.notify('warning', 'Already exists');
      }
    }
      else {
        this.notifier.notify('warning', 'Please Enter Base Enterprise Name');
      }

      
      
      
  }

  UpdateEnterprise() {
    if (this.form.valid) {
      var UpdateBody = {
        EnterpriseID: this.form.value.EnterpriseID,
        Enterprise: this.form.value.Enterprise,
      };
      this._apiService.post(config.urlpath + 'api/addenterprise', UpdateBody).subscribe(result => {
        if (result.Success === true) {
          $('#ModalClsbtn').click();
          this.notifier.notify('success', 'Base Enterprise Updated Successfully');
          this.GetEnterprise();
        } else {
          this.notifier.notify('error', 'An Error Occured');
        }
      },
        error => {
          console.log(error);
        }
      );
    }
    else {
      this.notifier.notify('error', 'Please Enter Base Enterprise Name');
    }
  }

  editEnterprise(item: any) {
    debugger;
    this.callForAddEnterprise = false;
    this.form.controls.EnterpriseID.patchValue(item.EnterpriseID);
    this.form.controls.Enterprise.patchValue(item.Enterprise);
  }
    onChange(event, item: any) {
    var IsActiveBody = {
      EnterpriseID: item,
      IsActive: event
    };
    this._apiService.post(config.urlpath + 'api/addenterprise', IsActiveBody).subscribe(result => {
      if (event) {
        this.notifier.notify('success', 'Base Enterprise Activated Successfully');
      }
      else {
        this.notifier.notify('warning', 'Base Enterprise  Deactivated Successfully');
      }
      debugger;
      console.log(result);
    })
  }
  keyPress(event: any) {
    debugger;
    const pattern = /^[a-zA-Z ]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  blurmetod(event: any) {
    event = event.replace(/\s\s+/g, ' ');
    $('#Enterprise').val(event);
  }

}
export interface EnterpriseInfo {
  EnterpriseID: string;
  Enterprise: number;
}